var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chart-render",
      style: {
        background:
          _vm.chartData.styleConfig &&
          _vm.chartData.styleConfig.commongConfig.customBackgroundColor
            ? _vm.chartData.styleConfig.commongConfig.backgroundColor
            : "#fff",
      },
    },
    [
      _vm.chartData.status === "-1"
        ? _c("div", { staticClass: "jzliu-bi-engine-chart-status" }, [
            _vm._m(0),
          ])
        : _vm.chartData.isExpired
        ? _c("div", { staticClass: "jzliu-bi-engine-chart-status" }, [
            _vm._m(1),
          ])
        : _c(_vm.computedTpl, {
            ref: "chartRenderRef",
            tag: "component",
            style: _vm.tplStyle,
            attrs: {
              chartConfigHandler: _vm.chartConfigHandler,
              isShowDrill: _vm.isShowDrill,
              chartData: _vm.chartData,
            },
            on: {
              "drill-item-click": _vm.handleDrillItemClick,
              "table-page-change": _vm.handleTablePageChange,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("img", {
        staticStyle: { display: "inline !important" },
        attrs: { src: require("../../assets/img/none.png") },
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { color: "#86909C", "margin-top": "12px" } }, [
        _vm._v("此指标已下架"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("img", {
        staticStyle: { display: "inline !important" },
        attrs: { src: require("../../assets/img/isExpired.png") },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            color: "#86909C",
            "font-size": "14px",
            "text-align": "center",
            "margin-top": "6px",
          },
        },
        [
          _c("div", [_vm._v("有效期过期")]),
          _vm._v(" "),
          _c("div", [_vm._v("可前往【我的申请】菜单【再次申请】")]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }